export default __webpack_public_path__ + "static/media/music-player.6b5ed1fa.jpg";